import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Menu from '@/views/Menu.vue';
import Rules from '@/views/Rules.vue';
import Prizes from '@/views/Prizes.vue';
import Contest from '@/views/Contest.vue';
import ContestInstructions from '@/views/ContestInstructions.vue';
import ContestGame from '@/views/ContestGame.vue';
import ContestQuestion from '@/views/ContestQuestion.vue';
import ContestPersonal from '@/views/ContestPersonal.vue';
import ContestLegals from '@/views/ContestLegals.vue';
import ContestEnd from '@/views/ContestEnd.vue';
import ContestError from '@/views/ContestError.vue';
import Panel from '@/views/Panel.vue';
import PanelLogin from '@/views/PanelLogin.vue';

Vue.use(Router);

export default new Router({
  scrollBehavior: () => ({
    x: 0,
    y: 0,
  }),
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu,
    },
    {
      path: '/rules',
      name: 'rules',
      component: Rules,
    },
    {
      path: '/prizes',
      name: 'prizes',
      component: Prizes,
    },
    {
      path: '/contest',
      component: Contest,
      children: [
        {
          path: '',
          redirect: 'instructions',
        },
        {
          path: 'instructions',
          name: 'contest instructions',
          component: ContestInstructions,
        },
        {
          path: 'game',
          name: 'contest game',
          component: ContestGame,
        },
        {
          path: 'question',
          name: 'contest question',
          component: ContestQuestion,
        },
        {
          path: 'personal',
          name: 'contest personal',
          component: ContestPersonal,
        },
        {
          path: 'legals',
          name: 'contest legals',
          component: ContestLegals,
        },
        {
          path: 'end',
          name: 'contest end',
          component: ContestEnd,
        },
        {
          path: 'error',
          name: 'contest error',
          component: ContestError,
          props: route => ({ backButtonTo: route.query.to }),
        },
      ],
    },
    {
      path: '/panel',
      component: Panel,
      children: [
        {
          path: '',
          redirect: 'login',
        },
        {
          path: 'login',
          name: 'login',
          component: PanelLogin,
        },
      ],
    },
    {
      path: '*',
      redirect: '/home',
    },
  ],
});
